import { djs } from '@duke-hq/djs';
import { RTO_TIMEZONE } from '@duke-hq/shared-constants/timezones';

// startOf('day') in a timezone lands an hour off on daylight saving changeover
// days, so each boundary is built from an explicit midnight instead.
function rtoMidnight(day: Date) {
  return djs.tz(`${djs(day).format('YYYY-MM-DD')} 00:00`, RTO_TIMEZONE);
}

// The picker returns calendar days in the browser's timezone. The server groups
// months in RTO_TIMEZONE, so the range has to start and end on days there too.
export function toRtoRange([start, end]: Date[]) {
  if (start == null || end == null) {
    return null;
  }
  return {
    fromDate: rtoMidnight(start).toDate(),
    toDate: rtoMidnight(djs(end).add(1, 'day').toDate()).subtract(1, 'millisecond').toDate(),
  };
}
